import React, { useState, useEffect } from 'react';
import { masterAdminAPI } from '../../services/api';
import { Link } from 'react-router-dom';
import StatCard from '../../components/common/StatCard';

const MasterDashboard = () => {
  const [stats, setStats] = useState({
    totalSchools: 0,
    pendingSchools: 0,
    totalPayments: 0,
    totalCredits: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [schoolsRes, paymentsRes] = await Promise.all([
        masterAdminAPI.getAllSchools(),
        masterAdminAPI.getAllPayments(),
      ]);
      const schools = schoolsRes.data;
      const payments = paymentsRes.data;
      const totalCredits = payments
        .filter(p => p.payment_type === 'credit_purchase' && p.payment_status === 'success')
        .reduce((sum, p) => sum + (p.credits || 0), 0);
      setStats({
        totalSchools: schools.length,
        pendingSchools: schools.filter(s => s.approval_status === 'pending').length,
        totalPayments: payments.length,
        totalCredits,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Master Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard title="Total Schools" value={stats.totalSchools} icon="fa-school" color="blue" />
        <StatCard title="Pending Approvals" value={stats.pendingSchools} icon="fa-clock" color="yellow" />
        <StatCard title="Total Payments" value={stats.totalPayments} icon="fa-credit-card" color="green" />
        <StatCard title="Credits Sold" value={stats.totalCredits} icon="fa-coins" color="purple" />
      </div>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <Link to="/master/pending" className="bg-white p-6 rounded-lg shadow hover:shadow-md">
          <h2 className="text-lg font-semibold mb-2">Pending Approvals</h2>
          <p className="text-gray-600">Review and approve new school registrations.</p>
        </Link>
        <Link to="/master/schools" className="bg-white p-6 rounded-lg shadow hover:shadow-md">
          <h2 className="text-lg font-semibold mb-2">Manage Schools</h2>
          <p className="text-gray-600">View all schools, add credits, suspend.</p>
        </Link>
      </div>
    </div>
  );
};

export default MasterDashboard;